module.exports = __webpack_public_path__ + "img/keyboard-up-arrow.e46870a6.svg";